var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.403.673a1.071 1.071 0 011.14.147l6.429 5.358a1.071 1.071 0 010 1.646L2.543 13.18a1.071 1.071 0 01-1.757-.823V1.643c0-.415.24-.793.617-.97z","fill":"currentColor"}));
}

PlayInline.defaultProps = {"width":"10","height":"14","fill":"none"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
